import React from "react";
import { Button } from "../../../ui/button";
import Image from "../../../Tags/Image";
import { useTheme } from "../../../ThemeProvider";
import { Lock, Play } from "lucide-react";
import Text from "../../../Tags/Text";
export default function CallAnalyticsAccessDenied() {
  const { theme } = useTheme();

  const handleUnlockInsights = () => {
    window.open("https://meetings-na2.hubspot.com/primerole", "_blank");
  };

  // const handleSeeInAction = () => {
  //   window.open("https://docs.primerole.com/analytics", "_blank");
  // };

  const handleContactSupport = () => {
    window.location.href =
      "mailto:support@primerole.com?cc=krishna@primerole.com&subject=I%20need%20help%20with%20PrimeRole&body=Please%20share%20feedback%2Fsuggestions%2Fbugs%20for%20the%20PrimeRole%20team%20";
  };

  return (
    <div className="min-h-screen bg-white dark:bg-gray-25 -mx-8">
      {/* Header Section */}
      {/* <div className="pb-3 pl-8 border-b border-gray-200 dark:border-gray-800 mb-3">
        <Text size="lg" className="text-[#101828] font-semibold">
          Activity
        </Text>
        <Text size="p" className="mt-1 text-text-500">
          Insights into call volume, quality, and conversions.
        </Text>
      </div> */}
      <div className="px-8 py-6">
        <div className="mb-3">
          <span className="text-[16px] font-semibold text-[#6941C6] dark:text-[#A78BFA]">Activity</span>
        </div>
        <h1 className="text-4xl font-semibold text-[#181D27] dark:text-white mb-5">
          See Beyond Calls with Activity Monitoring
        </h1>
        <p className="text-xl text-[#535862] dark:text-gray-400 max-w-4xl font-normal">
          Unlock powerful metrics that go beyond call counts — track connect rates, monitor activity, and find
          best times to call, to turn every conversation into measurable impact.
        </p>
      </div>

      {/* Main Content */}
      <div className="pl-8 py-12">
        <div>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start">
            <div className="space-y-6">
              <div className="bg-[#F5F5F5] dark:bg-[#121926] rounded-xl p-6">
                <div className="w-12 h-12 rounded-lg flex items-center justify-center mb-12">
                  <Image
                    src="/images/icons/untitledui/call-activity/star-icon.svg"
                    alt="Analytics"
                    width={48}
                    height={48}
                    className="no-invert"
                  />
                </div>
                <h2 className="text-lg font-semibold text-[#181D27] dark:text-white mb-1">
                  Call Analytics for Every Team, at Any Scale.
                </h2>
                <p className="text-[#535862] text-base dark:text-white mb-4 leading-relaxed">
                  Whether you have a team of 2 or 2000, Call Analytics delivers detailed performance insights
                  across reps, teams, and countries — and much more.
                </p>
                <div className="flex flex-col sm:flex-row gap-3">
                  <Button
                    onClick={handleUnlockInsights}
                    className="bg-[#7F56D9] hover:bg-[#6941C6] text-white px-4 py-2 rounded-lg shadow-md flex items-center gap-2 font-semibold text-sm"
                  >
                    <Image
                      src="/images/icons/untitledui/call-activity/lock-Icon.svg"
                      alt="Lock"
                      width={16}
                      height={16}
                      className="no-invert"
                    />
                    Unlock insights
                  </Button>
                  {/* <Button
                    variant="outline"
                    onClick={handleSeeInAction}
                    className="border-[#D5D7DA] dark:border-gray-600 text-[#414651] dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700 px-4 py-2 rounded-lg shadow-md flex items-center gap-2 font-semibold text-sm"
                  >
                    <Play size={16} />
                    See it in action
                  </Button> */}
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div className="bg-[#F5F5F5] dark:bg-[#121926] rounded-xl p-6">
                  <div className="w-12 h-12  rounded-lg flex items-center justify-center mb-12 ">
                    <Image
                      src="/images/icons/untitledui/call-activity/doc.svg"
                      alt="Documentation"
                      width={48}
                      height={48}
                      className="no-invert"
                    />
                  </div>
                  <h3 className="font-semibold text-[#101828] dark:text-white mb-1">About Call Analytics</h3>
                  <p className="text-sm text-[#475467] dark:text-white mb-4 leading-relaxed">
                    Read the Call Analytics docs to explore features, setup, and best practices.
                  </p>
                  <button
                    onClick={() => {
                      const docsUrl = `${process.env.REACT_APP_BASE_URL}/docs/`;
                      window.open(docsUrl, "_blank");
                    }}
                    className="text-base text-[#6941C6] hover:text-[#7F56D9] dark:text-[#A78BFA] dark:hover:text-[#C4B5FD] font-semibold flex items-center gap-1"
                  >
                    View docs →
                  </button>
                </div>

                <div className="bg-[#F5F5F5] dark:bg-[#121926] rounded-xl p-6">
                  <div className="w-12 h-12  rounded-lg flex items-center justify-center mb-12 ">
                    <Image
                      src="/images/icons/untitledui/call-activity/head-phone.svg"
                      alt="Support"
                      width={48}
                      height={48}
                      className="no-invert"
                    />
                  </div>
                  <h3 className="font-semibold text-[#101828] dark:text-white mb-1">Need help?</h3>
                  <p className="text-sm text-[#475467] dark:text-white mb-4 leading-relaxed">
                    Need assistance with Call Analytics? We're here to help you anytime.
                  </p>
                  <button
                    onClick={handleContactSupport}
                    className="text-base text-[#6941C6] hover:text-[#7F56D9] dark:text-[#A78BFA] dark:hover:text-[#C4B5FD] font-semibold flex items-center gap-1"
                  >
                    Contact support →
                  </button>
                </div>
              </div>
            </div>

            <div className="lg:sticky lg:top-8">
              <div className="relative">
                <div className="rounded-xl overflow-hidden">
                  {theme === "dark" ? (
                    <Image
                      src="/images/icons/untitledui/call-activity/dark-call-activity-403.png"
                      alt="Call Analytics Preview"
                      className="w-full h-auto no-invert"
                    />
                  ) : (
                    <Image
                      src="/images/icons/untitledui/call-activity/call-activity-403.png"
                      alt="Call Analytics Preview"
                      className="w-full h-auto"
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
